import PropTypes from 'prop-types'
import React from 'react'
import { findDOMNode } from 'react-dom'
import { injectIntl, FormattedMessage } from 'react-intl'
import RelativeDate from 'components/RelativeDate'
import {
  ContentBody,
} from 'components/Content'
import KanBoIcon from 'components/KanBoIcon'
import Sortable from 'components/Sortable'
import Element from '../Element'
import ElementInfo from '../ElementInfo'
import { withBoardPermission } from 'dataProviders/Board'
import { ModalBoardContext } from 'components/Modal'
import { DropTarget } from 'react-dnd'
import { dragType as documentDragType } from 'components/Document/Document'
import { NativeTypes } from 'react-dnd-html5-backend'
import withLeftSidebar from 'components/Sidebar/withLeftSidebar'
import {
  MenuItem
} from 'components/Menu'
import SelectedDocumentTemplates from '../SelectedDocumentTemplates'
import AddDocumentButton from './AddDocumentButton'
import DocumentListItem from './DocumentListItem'

const draggableOverStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: '#ccc',
  zIndex: 5,
  opacity: 0.5,
  pointerEvents: 'none',
}

export class DocumentList extends React.Component {
  static propTypes = {
    id: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
    sortable: PropTypes.object.isRequired,

    boardId: PropTypes.number.isRequired,
    cardId: PropTypes.number.isRequired,
    isCardArchived: PropTypes.bool.isRequired,
    items: PropTypes.array.isRequired,
    latestDocumentUpdate: PropTypes.number,
    isBusy: PropTypes.bool,

    requestPositionDocumentListItem: PropTypes.func.isRequired,
    requestUploadStart: PropTypes.func.isRequired,

    permission: PropTypes.object.isRequired,

    connectDocumentDropTarget: PropTypes.func.isRequired,
    isDocumentOver: PropTypes.bool.isRequired
  }

  handleDocumentListItemPositionChange = ({ itemId, parentId, position }) => {
    this.props.requestPositionDocumentListItem({
      cardId: this.props.cardId,
      documentListItemId: itemId,
      documentListId: parentId,
      position
    })
  }

  handleSettingsClick = () => {
    this.props.leftSidebar.push(() =>
      <ModalBoardContext boardId={this.props.boardId}>
        <SelectedDocumentTemplates documentListId={this.props.id} />
      </ModalBoardContext>
    )
  }

  renderDocumentListItem = React.forwardRef((props, ref) =>
    <DocumentListItem {...props} ref={ref} documentListId={this.props.id} />
  )

  render () {
    const {
      id,
      sortable,

      permission,

      isCardArchived,
      items,
      latestDocumentUpdate,
      isBusy,

      connectDocumentDropTarget,
      isDocumentOver
    } = this.props

    return (
      <Sortable
        vertical
        containerTag='ul'
        className='list-group'
        name={'documentListItems'}
        id={id}
        component={this.renderDocumentListItem}
        items={items}
        disabled={isBusy || isCardArchived || !permission.member}
        onPositionChange={this.handleDocumentListItemPositionChange}
      >
        {({ renderContainer, connectDropTarget }) =>
          <Element
            ref={ref => {
              const node = !isBusy ? findDOMNode(ref) : null

              connectDropTarget(node)
              connectDocumentDropTarget(node)
            }}
            id={id}
            icon={<KanBoIcon name='kanbo-24-document-group' />}
            collapsible
            sortable={sortable}
            menu={
              (!isCardArchived && permission.member) ? (
                <MenuItem
                  icon={<KanBoIcon name='kanbo-16-settings' />}
                  onClick={this.handleSettingsClick}
                >
                  <FormattedMessage id='SETTINGS' />
                </MenuItem>
              ) : undefined
            }
          >
            {(collapsed) => (
              <React.Fragment>
                {isDocumentOver && <span style={draggableOverStyle} />}
                <ContentBody
                  style={!collapsed ? { padding: 0 } : null}
                >
                  {collapsed &&
                    <React.Fragment>
                      <ElementInfo
                        icon={<KanBoIcon name='kanbo-16-documents' />}
                      >
                        {items.length}
                      </ElementInfo>
                      {Boolean(latestDocumentUpdate) &&
                        <ElementInfo
                          icon={<KanBoIcon name='kanbo-16-docs-update-2' />}
                        >
                          <RelativeDate pastOnly timestamp={latestDocumentUpdate} />
                        </ElementInfo>
                      }
                    </React.Fragment>
                  }
                  <div style={collapsed ? { display: 'none' } : undefined}>
                    {renderContainer()}
                  </div>
                </ContentBody>
                {(!collapsed && !isCardArchived && permission.member) && (
                  <AddDocumentButton
                    documentListId={id}
                  />
                )}
              </React.Fragment>
            )}
          </Element>
        }
      </Sortable>
    )
  }
}

const documentDropTarget = {
  canDrop (props) {
    return props.permission.member
  },

  drop (props, monitor) {
    const { id, boardId, requestAddDocumentToDocumentList, requestUploadStart } = props
    const { files, url, documentSourceId } = monitor.getItem()

    if (files) {
      var count = files.length

      if (count > 0) {
        for (var i = 0; i < count; i++) {
          requestUploadStart({
            boardId,
            file: files[i],
            onUpload: ({ url, documentSourceId }) => {
              requestAddDocumentToDocumentList({
                documentListId: id,
                url,
                documentSourceId,
              })
            }
          })
        }
      }
    } else {
      requestAddDocumentToDocumentList({
        documentListId: id,
        url,
        documentSourceId,
      })
    }
  }
}

export default
withBoardPermission(DropTarget(
  [NativeTypes.FILE, documentDragType],
  documentDropTarget,
  (connect, monitor) => ({
    connectDocumentDropTarget: connect.dropTarget(),
    isDocumentOver: monitor.isOver()
  })
)(injectIntl(withLeftSidebar(DocumentList), { forwardRef: true })))
